module.exports = __webpack_public_path__ + "img/始.f9df92f5.png";